'use strict';

jQuery(function ($) {
    // Au scroll faire apparaitre ou disparaitre le bouton de retour en haut de page
    $(window).on('scroll', function () {
        var $back = $('.back-to-top');
        var duration = 600;
        var posScroll = $(document).scrollTop();

        if (posScroll >= 550) {
            $back.fadeIn(duration);
        } else {
            $back.fadeOut(duration);
        }
    });

    $('.back-to-top').on('click', function (event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 500);
    });

    // Filtres
    $('.filtres a').click(function (e) {
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active');
        var a = $(this).attr('href');
        a = a.substr(1);
        $('.sets a').each(function () {
            if (!$(this).hasClass(a) && a != 'all') $(this).parent().addClass('hide'); else $(this).parent().removeClass('hide');
        });
    });

    // Accordion pour les articles.
    $('.accordion-toggle.collapse.in').removeClass('in').css('height', '');
    $('.accordion-heading').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $showed = $('.accordion-body.show');
        $(this).parent().addClass('actif').siblings().removeClass('actif');
        $(this).next('.accordion-body').toggleClass('show').css('height', '');
        if ($(this).parent().index() !== $showed.parent().index()) {
            $showed.toggleClass('show').css('height', '');
            $(this).parent().addClass('actif');
        } else {
            $(this).parent().removeClass('actif');
        }
    });

    /* SideBar Menu On click */
    var $menu_left = $(".side-nav-left");
    var $toggler = $("#menu_bars");
    if ($("#menu_bars").length) {
        $("#side-nav").addClass("side-nav-push");

        if ($toggler.hasClass("left")) {
            $toggler.on("click", function (e) {
                $(this).toggleClass("active");

                $menu_left.toggleClass("side-nav-open");
                e.stopPropagation();
            });
        } else {
            if ($toggler.hasClass("full")) {
                $toggler.on("click", function (e) {
                    $(this).toggleClass("active");
                    $menu_full.toggleClass("side-nav-open");
                    e.stopPropagation();
                });
            }
        }
    }
});
